import { problemText, type ApiError } from '@/shared/api';

/**
 * Die Gastzugangs-Endpunkte schicken als `detail` Entwicklertext auf Englisch („Booking has no
 * GuestProfile yet.“). Gezeigt wird deshalb der Satz zum Code; der Code bleibt für den Support dabei.
 */
const TEXT: Record<string, string> = {
  guest_email_missing:
    'Am Gast fehlt eine E-Mail-Adresse – ohne sie kann kein Link verschickt werden.',
  booking_without_guest: 'Die Buchung hat noch kein Gastprofil.',
  booking_not_found: 'Diese Buchung gibt es nicht mehr.',
  booking_stay_completed: 'Der Gast ist abgereist – eine neue Begrüßung geht nicht mehr.',
  guest_profile_not_found: 'Das Gastprofil dieser Buchung fehlt.',
  guest_access_source_busy:
    'Gerade läuft schon eine Zustellung – bitte kurz warten und dann erneut versuchen.',
  onboarding_delivery_in_progress:
    'Gerade läuft schon eine Zustellung – bitte kurz warten und dann erneut versuchen.',
  guest_access_stale: 'Die Buchung hat sich gerade geändert – bitte die Seite neu laden.',
  onboarding_delivery_reissue_required:
    'Der Zugang ist abgelaufen oder widerrufen – bitte neu ausstellen.',
  onboarding_delivery_not_dead_lettered: 'Diese Zustellung lässt sich nicht erneut versuchen.',
  onboarding_delivery_not_retryable: 'Diese Zustellung lässt sich nicht erneut versuchen.',
  onboarding_delivery_not_found: 'Diese Zustellung gibt es nicht mehr.',
  onboarding_delivery_external_booking_missing:
    'Über den Kanal lässt sich diese Nachricht nicht zustellen: die Kanal-Buchung fehlt.',
  onboarding_delivery_channel_missing:
    'Über den Kanal lässt sich diese Nachricht nicht zustellen: der Kanal ist unbekannt.',
  onboarding_delivery_channel_unsupported:
    'Dieser Kanal nimmt keine Nachrichten vom Kanalmanager an.',
};

export function onboardingErrorText(problem: ApiError, fallback: string): string {
  return problemText(problem, fallback, { known: TEXT });
}
